import { useState } from 'react';
import { StylishNewButton } from 'components/DesignSystems/New/StylishNewButton';
import { StylishNewSearchBar } from 'components/DesignSystems/New/StylishNewSearchBar';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { CreateFeatureForm } from './CreateFeatureForm';
import { InternalLayer } from 'hooks/internalLayer/types';
import { LocationInput } from 'types/locations';

type LayerFeaturesEditorProps = {
  internalLayer?: InternalLayer | null;
  showAddObjectButton?: boolean;
  showSearch?: boolean;
  onSubmitLocation: ({
    location,
    pendingGraphicId,
  }: {
    location: LocationInput;
    pendingGraphicId?: string;
  }) => Promise<void> | void;
  onCancelLocation?: () => void;
};

export function LayerFeaturesEditor({
  internalLayer,
  showAddObjectButton,
  showSearch = true,
  onSubmitLocation,
  onCancelLocation,
}: LayerFeaturesEditorProps) {
  const [searchTerm, setSearchTerm] = useState('');
  const [isFormOpen, setIsFormOpen] = useState(false);

  return (
    <div className="layer-objects-editor">
      <div className="d-flex align-items-end gap-2 mb-2">
        {showSearch && (
          <div className="flex-grow-1">
            <StylishNewSearchBar
              label="Objects"
              placeholder="Search..."
              value={searchTerm}
              onChangeSearchTerm={setSearchTerm}
            />
          </div>
        )}
        {showAddObjectButton && (
          <StylishNewButton
            className="button--secondary"
            onClick={() => setIsFormOpen(!isFormOpen)}
          >
            <SharedIcon iconName="add" size="sm" />
            Add Object
          </StylishNewButton>
        )}
      </div>

      {isFormOpen && (
        <CreateFeatureForm
          internalLayer={internalLayer}
          onSubmit={onSubmitLocation}
          onClose={() => setIsFormOpen(false)}
          onDiscard={onCancelLocation}
        />
      )}
    </div>
  );
}
